import { ExternalServiceAssignee } from "@web-app/types";
import http from "@web-app/utils/http";

export const getExternalServiceAssignee = async (
  entity: string,
  id: string,
) => {
  return http
    .get<ExternalServiceAssignee>(
      `/integrations/externalServiceAssignee/${entity}/${id}`,
    )
    .then((response) => response.data)
    .catch(() => null);
};
